export default class Helper {
	constructor() { }

	serializeForm(form) {
		if (!form) { return false; }

		const data = {};
		const formData = new FormData(form);

		for (const entry of formData.entries()) {
			const key = entry[0];
			const value = entry[1];
			if (key in data) {
				if (!Array.isArray(data[key])) {
					data[key] = [data[key]];
				}
				data[key].push(value);
			} else {
				data[key] = value;
			}
		}
		return data;
	}

	openModal(target) {
		if (!target) return;

		window.theme.components?.modal?.open(target);
	}

	closeModal(target) {
		if (!target) return;

		window.theme.components?.modal?.close(target);
	}

	logMessage(message, type, options) {
		if (!message || !type) return;

		const defaults = {
			type: type ? type : 'success',
			target: document.querySelector('.is-root-container'),
			class: 'log',
			duration: 10000,
			close: true,
		};

		const config = { ...defaults, ...options };

		const el = document.createElement('div');
		el.classList.add(config.class, `log-${config.type}`);
		el.innerHTML = message;

		config.target.appendChild(el);

		el.style.opacity = 1;

		setTimeout(() => {
			el.style.opacity = 0;
			setTimeout(() => el.remove(), 500);
		}, config.duration);
	}

	formatPrice(value) {
		return value?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
	}

	throttle(callback, limit) {
		let wait = false;
		return function (...args) {
			if (!wait) {
				callback.apply(this, args);
				wait = true;
				setTimeout(() => {
					wait = false;
				}, limit);
			}
		};
	}

	debounce(callback, delay) {
		let timeout;
		return function (...args) {
			clearTimeout(timeout);
			timeout = setTimeout(() => {
				callback.apply(this, args);
			}, delay);
		};
	}
}